import { createSlice } from '@reduxjs/toolkit';
import { fetchDocumentApprovals } from './ApprovalsApi';

const fetchDocumentApprovalsSlice = createSlice({
    name: 'fetchDocumentApprovals',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchCommunityData cases
            .addCase(fetchDocumentApprovals.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDocumentApprovals.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchDocumentApprovals.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default fetchDocumentApprovalsSlice.reducer;
